import React from 'react';

import { cnSkeleton } from './Skeleton.const';
import type { ISkeletonProps } from './Skeleton.typings';

import './Skeleton.scss';

export const Skeleton: React.FC<ISkeletonProps> = props => (
    <div className={cnSkeleton(null, [props.className])}></div>
);
